import React, { useState, useEffect, useRef, useCallback } from 'react';

import BackButtonRouter from '../../Components/BackButtonRouter';
import AppConfig from '../../AppConfig';
import APIGet from '../../API/APIGet';
import APIPost from '../../API/APIPost';
import APIPut from '../../API/APIPut';
import APIDelete from '../../API/APIDelete';
import { NeedTab } from './Components/NeedTab';

import { ReactComponent as PhoneIcon } from '../../Assets/phone_iphone.svg';
import { ReactComponent as EmailIcon } from '../../Assets/assign.svg';
import { ReactComponent as LineIcon } from '../../Assets/Line.svg';
import { ReactComponent as BirthdayCakeIcon } from '../../Assets/bd_cake.svg';
import { ReactComponent as FacebookIcon } from '../../Assets/facebook.svg';
import { ReactComponent as HouseIcon } from '../../Assets/house.svg';

import { PassportTab } from './Components/PassportTab';
import { VisaTab } from './Components/VisaTab';
import { fileToBase64 } from '../../Helper/FileHelper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faCheck, faTimes, faTrashAlt, faImage, faUser, faIdCard, faPassport, faCalendarDays, faChild } from '@fortawesome/free-solid-svg-icons';
import { IncentiveTab } from './Components/IncentiveTab';
import { FitVisaTab } from './Components/FitVisaTab';
import { FitFlightTab } from './Components/FitFlightTab';
import { FitTicketTab } from './Components/FitTicketTab';
import { FitHotelTab } from './Components/FitHotelTab';
import { FitInsureTab } from './Components/FitInsureTab';
import { FitCarTab } from './Components/FitCarTab';
import { FitTranslateTab } from './Components/FitTranslateTab';
import { FitInternetTab } from './Components/FitInternetTab';
import { toast } from 'react-toastify';
import Select from 'react-select';
import NATIONALITY_OPTIONS from '../../StaticData/Nationality';
import {
	getProvinceSelectOptions,
	getCitySelectOptions,
	getTownSelectOptions,
	getProvinceFromName,
	getCityFromName,
	getTownFromName,
} from '../../Helper/ThailandSelectOption';

const emptyTraveler = {
	id: null,
	firstName: '',
	middleName: '',
	lastName: '',
	thaiFirstName: '',
	thaiMiddleName: '',
	thaiLastName: '',
	title: '',
	nationality: '',
	phone: '',
	email: '',
	line: '',
	facebook: '',
	birthday: '',
	age: '',
	idCardNumber: '',
	passportNumber: '',
	passportExpiryDate: '',
	address1: '',
	postcode: '',
	province: '',
	city: '',
	town: '',
	avatarUrl: '',
	preferFood: '',
	preferHotel: '',
	preferRoom: '',
	preferBed: '',
	preferAirline: '',
	preferSeat: '',
	preferEtc: '',
	cautionFoodAllergic: '',
	cautionMedicineAllergic: '',
	cautionMedicalInfo: '',
	cautionEtcWarning: '',
};

const mockPrograms = [
	{
		id: 'P1E180',
		name: 'GW Vel quidem et sint tenetur.',
		date: '26 Jan - 4 Feb 2026',
		pax: 24,
		customer: 'Rogahn-Rosenbaum',
	},
];

/** Portals menu to body so it stacks above later sections (e.g. passport cards below address). */
const TRAVELER_ADDRESS_SELECT_STYLES = {
	menuPortal: base => ({ ...base, zIndex: 10050 }),
};

const MAX_IMAGE_BYTES = 1 * 1024 * 1024;

const ENGLISH_NAME_TITLE_OPTIONS = ['Mr.', 'Mrs.', 'Ms.', 'Miss.', 'Mstr.'];

function toInputDateString(value) {
	if (value == null || value === '') return '';
	const s = String(value).trim();
	return /^\d{4}-\d{2}-\d{2}/.test(s) ? s.slice(0, 10) : s;
}

function mapTravelerPayload(payload) {
	const nextTraveler = { ...emptyTraveler };
	if (!payload) return nextTraveler;

	nextTraveler.id = payload.id != null ? payload.id : nextTraveler.id;
	nextTraveler.firstName = payload.firstName != null ? payload.firstName : '';
	nextTraveler.middleName = payload.middleName != null ? payload.middleName : '';
	nextTraveler.lastName = payload.lastName != null ? payload.lastName : '';
	nextTraveler.thaiFirstName = payload.thaiFirstName != null ? payload.thaiFirstName : '';
	nextTraveler.thaiMiddleName = payload.thaiMiddleName != null ? payload.thaiMiddleName : '';
	nextTraveler.thaiLastName = payload.thaiLastName != null ? payload.thaiLastName : '';
	nextTraveler.title =
		payload.title != null && payload.title !== ''
			? String(payload.title)
			: payload.englishTitle != null && payload.englishTitle !== ''
			? String(payload.englishTitle)
			: '';
	nextTraveler.nationality = payload.nationality != null ? String(payload.nationality) : '';
	nextTraveler.phone = payload.telephone != null ? payload.telephone : '';
	nextTraveler.email = payload.email != null ? payload.email : '';
	nextTraveler.line = payload.line != null ? payload.line : '';
	nextTraveler.facebook = payload.facebook != null ? payload.facebook : '';
	nextTraveler.birthday = toInputDateString(payload.birthDay != null ? payload.birthDay : '');
	nextTraveler.age = payload.age != null && payload.age !== '' ? String(payload.age) : '';
	nextTraveler.idCardNumber = payload.idCardNumber != null && payload.idCardNumber !== '' ? String(payload.idCardNumber) : '';
	nextTraveler.passportNumber = payload.passportNumber != null ? String(payload.passportNumber) : '';
	nextTraveler.passportExpiryDate = toInputDateString(
		payload.passportExpiryDate != null ? payload.passportExpiryDate : payload.passportExpireDate != null ? payload.passportExpireDate : ''
	);
	nextTraveler.address1 = payload.address1 != null ? payload.address1 : '';
	nextTraveler.postcode = payload.postcode != null ? payload.postcode : '';
	nextTraveler.province = payload.province != null ? payload.province : '';
	nextTraveler.city = payload.city != null ? payload.city : '';
	nextTraveler.town = payload.town != null ? payload.town : '';
	nextTraveler.avatarUrl = payload.profileImage != null ? payload.profileImage : '';
	nextTraveler.preferFood = payload.preferFood != null ? payload.preferFood : '';
	nextTraveler.preferHotel = payload.preferHotel != null ? payload.preferHotel : '';
	nextTraveler.preferRoom = payload.preferRoom != null ? payload.preferRoom : '';
	nextTraveler.preferBed = payload.preferBed != null ? payload.preferBed : '';
	nextTraveler.preferAirline = payload.preferAirline != null ? payload.preferAirline : '';
	nextTraveler.preferSeat = payload.preferSeat != null ? payload.preferSeat : '';
	nextTraveler.preferEtc = payload.preferEtc != null ? payload.preferEtc : '';
	nextTraveler.cautionFoodAllergic = payload.cautionFoodAllergic != null ? payload.cautionFoodAllergic : '';
	nextTraveler.cautionMedicineAllergic = payload.cautionMedicalInfo != null ? payload.cautionMedicalInfo : '';
	nextTraveler.cautionEtcWarning = payload.cautionEtcWarning != null ? payload.cautionEtcWarning : '';

	return nextTraveler;
}

export default function TravelerDetail(props) {
	const travelerIdFromRoute = props && props.match && props.match.params ? props.match.params.travelerId || props.match.params.id : null;
	const isCreateMode = travelerIdFromRoute === 'new' || travelerIdFromRoute == null || travelerIdFromRoute === '';
	const travelerIdForApi = !isCreateMode ? travelerIdFromRoute : null;
	const [isEditingProfile, setIsEditingProfile] = useState(false);
	const [isEditingNeeds, setIsEditingNeeds] = useState(false);
	const [activeTab, setActiveTab] = useState('needs');
	const [activeProgramTab, setActiveProgramTab] = useState('incentive');
	const [traveler, setTraveler] = useState(() => ({ ...emptyTraveler }));
	const [isLoadingTraveler, setIsLoadingTraveler] = useState(false);
	const [isSavingProfile, setIsSavingProfile] = useState(false);
	const [isSavingNeeds, setIsSavingNeeds] = useState(false);
	const [profileFieldErrors, setProfileFieldErrors] = useState({ firstName: false, lastName: false });

	const [provinceSelectOptions, setProvinceSelectOptions] = useState([]);
	const [citySelectOptions, setCitySelectOptions] = useState([]);
	const [townSelectOptions, setTownSelectOptions] = useState([]);
	const [selectedProvince, setSelectedProvince] = useState(null);
	const [selectedCity, setSelectedCity] = useState(null);
	const [selectedTown, setSelectedTown] = useState(null);

	const selectedProvinceRef = useRef(null);
	selectedProvinceRef.current = selectedProvince;

	const fileInputRef = useRef(null);
	const avatarObjectUrlRef = useRef(null);
	const avatarFileRef = useRef(null);
	const profileImageBinaryRef = useRef(null);

	const originalTravelerRef = useRef(null);
	const originalGeoRef = useRef({ selectedProvince: null, selectedCity: null, selectedTown: null });
	const originalAvatarUrlRef = useRef(null);
	const originalNeedsRef = useRef(null);

	useEffect(() => {
		let isActive = true;

		const loadTraveler = async () => {
			if (!isActive) return;
			if (isCreateMode) {
				const provinceOptions = getProvinceSelectOptions();
				setProvinceSelectOptions(provinceOptions);
				setCitySelectOptions([]);
				setTownSelectOptions([]);
				setSelectedProvince(null);
				setSelectedCity(null);
				setSelectedTown(null);
				setTraveler({ ...emptyTraveler });
				setIsEditingProfile(true);
				setIsEditingNeeds(false);
				setProfileFieldErrors({ firstName: false, lastName: false });
				setIsLoadingTraveler(false);
				return;
			}

			setIsLoadingTraveler(true);

			// Fetch real traveler by route id (e.g. /travelers/:travelerId).
			const result = await APIGet('travelers/' + travelerIdForApi);
			const payload = result && result.data ? result.data : null;
			const nextTraveler = mapTravelerPayload(payload);

			// Ensure initial edit mode is off.
			setIsEditingProfile(false);
			setIsEditingNeeds(false);

			setTraveler(nextTraveler);

			// Province/city/town Select initialization (driven by string names from API).
			const provinceOptions = getProvinceSelectOptions();
			setProvinceSelectOptions(provinceOptions);

			if (nextTraveler.province) {
				const prov = getProvinceFromName(nextTraveler.province);
				if (prov) {
					const cities = getCitySelectOptions(prov);
					const city = getCityFromName(prov, nextTraveler.city);
					const towns = getTownSelectOptions(prov, city);
					const town = getTownFromName(prov, city, nextTraveler.town);

					setSelectedProvince(prov);
					setCitySelectOptions(cities);
					setSelectedCity(city);
					setTownSelectOptions(towns);
					setSelectedTown(town);
				}
			}

			setIsLoadingTraveler(false);
		};

		loadTraveler();
		return () => {
			isActive = false;
		};
	}, [isCreateMode, travelerIdForApi]);

	useEffect(() => {
		return () => {
			if (avatarObjectUrlRef.current) URL.revokeObjectURL(avatarObjectUrlRef.current);
		};
	}, []);

	const startEditNeeds = useCallback(() => {
		originalNeedsRef.current = {
			preferFood: traveler.preferFood,
			preferHotel: traveler.preferHotel,
			preferRoom: traveler.preferRoom,
			preferBed: traveler.preferBed,
			preferAirline: traveler.preferAirline,
			preferSeat: traveler.preferSeat,
			preferEtc: traveler.preferEtc,
			cautionFoodAllergic: traveler.cautionFoodAllergic,
			cautionMedicineAllergic: traveler.cautionMedicineAllergic,
			cautionEtcWarning: traveler.cautionEtcWarning,
		};
		setIsEditingNeeds(true);
		setIsSavingNeeds(false);
	}, [traveler]);

	const handleCancelNeeds = useCallback(() => {
		const orig = originalNeedsRef.current;
		if (orig) {
			setTraveler(prev => ({
				...prev,
				preferFood: orig.preferFood,
				preferHotel: orig.preferHotel,
				preferRoom: orig.preferRoom,
				preferBed: orig.preferBed,
				preferAirline: orig.preferAirline,
				preferSeat: orig.preferSeat,
				preferEtc: orig.preferEtc,
				cautionFoodAllergic: orig.cautionFoodAllergic,
				cautionMedicineAllergic: orig.cautionMedicineAllergic,
				cautionEtcWarning: orig.cautionEtcWarning,
			}));
		}
		setIsEditingNeeds(false);
		setIsSavingNeeds(false);
	}, []);

	const handleSaveNeeds = useCallback(async () => {
		if (isSavingNeeds) return;
		setIsSavingNeeds(true);
		try {
			const requestBody = {
				preferFood: traveler.preferFood,
				preferHotel: traveler.preferHotel,
				preferRoom: traveler.preferRoom,
				preferBed: traveler.preferBed,
				preferAirline: traveler.preferAirline,
				preferSeat: traveler.preferSeat,
				preferEtc: traveler.preferEtc,
				cautionFoodAllergic: traveler.cautionFoodAllergic,
				cautionMedicalInfo: traveler.cautionMedicineAllergic,
				cautionEtcWarning: traveler.cautionEtcWarning,
			};
			const request = await APIPut('travelers/' + travelerIdForApi + '/prefs', requestBody);
			if (request && request.status >= 200 && request.status < 300) {
				originalNeedsRef.current = {
					preferFood: traveler.preferFood,
					preferHotel: traveler.preferHotel,
					preferRoom: traveler.preferRoom,
					preferBed: traveler.preferBed,
					preferAirline: traveler.preferAirline,
					preferSeat: traveler.preferSeat,
					preferEtc: traveler.preferEtc,
					cautionFoodAllergic: traveler.cautionFoodAllergic,
					cautionMedicineAllergic: traveler.cautionMedicineAllergic,
					cautionEtcWarning: traveler.cautionEtcWarning,
				};
				setIsEditingNeeds(false);
				toast.success('Traveler needs บันทึกสำเร็จ');
			} else {
				console.log('Failed to update traveler prefs', request);
				toast.error('ไม่สามารถบันทึก Traveler needs ได้ กรุณาลองใหม่อีกครั้ง');
			}
		} catch (e) {
			console.log(e);
		} finally {
			setIsSavingNeeds(false);
		}
	}, [APIPut, isSavingNeeds, traveler, travelerIdForApi]);

	const startEditProfile = useCallback(() => {
		originalTravelerRef.current = { ...traveler };
		originalGeoRef.current = { selectedProvince, selectedCity, selectedTown };
		originalAvatarUrlRef.current = traveler.avatarUrl;

		// Clear any previous binary payload (will be recreated if user changes avatar).
		avatarFileRef.current = null;
		profileImageBinaryRef.current = null;

		setIsEditingProfile(true);
		setIsSavingProfile(false);
		setProfileFieldErrors({ firstName: false, lastName: false });
	}, [selectedCity, selectedProvince, selectedTown, traveler]);

	const handleCancelProfile = useCallback(() => {
		if (isCreateMode) {
			window.history.back();
			return;
		}

		// Revert traveler data
		if (originalTravelerRef.current) setTraveler({ ...originalTravelerRef.current });

		// Revert geo selections/options
		const origGeo = originalGeoRef.current || { selectedProvince: null, selectedCity: null, selectedTown: null };
		setSelectedProvince(origGeo.selectedProvince || null);
		setSelectedCity(origGeo.selectedCity || null);
		setSelectedTown(origGeo.selectedTown || null);

		if (origGeo.selectedProvince) {
			setCitySelectOptions(getCitySelectOptions(origGeo.selectedProvince));
			setTownSelectOptions(origGeo.selectedCity ? getTownSelectOptions(origGeo.selectedProvince, origGeo.selectedCity) : []);
		} else {
			setCitySelectOptions([]);
			setTownSelectOptions([]);
		}

		// Revert avatar preview and payload (avatarUrl is part of traveler snapshot).
		const avatarChangedThisEdit = !!avatarFileRef.current;
		if (avatarChangedThisEdit && avatarObjectUrlRef.current) URL.revokeObjectURL(avatarObjectUrlRef.current);
		if (avatarChangedThisEdit) {
			const origAvatarUrl = originalAvatarUrlRef.current;
			avatarObjectUrlRef.current = origAvatarUrl && String(origAvatarUrl).startsWith('blob:') ? origAvatarUrl : null;
		}
		avatarFileRef.current = null;
		profileImageBinaryRef.current = null;

		if (fileInputRef.current) fileInputRef.current.value = '';

		setIsEditingProfile(false);
		setIsSavingProfile(false);
		setProfileFieldErrors({ firstName: false, lastName: false });
	}, [isCreateMode, props.history]);

	const handleSaveProfile = useCallback(async () => {
		if (isSavingProfile) return;
		const firstNameInvalid = !String(traveler.firstName || '').trim();
		const lastNameInvalid = !String(traveler.lastName || '').trim();
		if (firstNameInvalid || lastNameInvalid) {
			setProfileFieldErrors({
				firstName: firstNameInvalid,
				lastName: lastNameInvalid,
			});
			return;
		}

		setProfileFieldErrors({ firstName: false, lastName: false });
		setIsSavingProfile(true);

		try {
			const requestBody = {
				firstName: traveler.firstName,
				middleName: traveler.middleName,
				lastName: traveler.lastName,
				thaiFirstName: traveler.thaiFirstName,
				thaiMiddleName: traveler.thaiMiddleName,
				thaiLastName: traveler.thaiLastName,
				title: traveler.title,
				nationality: traveler.nationality,
				telephone: traveler.phone,
				email: traveler.email,
				line: traveler.line,
				address1: traveler.address1,
				postcode: traveler.postcode,
				province: traveler.province,
				city: traveler.city,
				town: traveler.town,
				birthDay: traveler.birthday,
				idCardNumber: traveler.idCardNumber,
				passportNumber: traveler.passportNumber,
				passportExpiryDate: traveler.passportExpiryDate,
				facebook: traveler.facebook,
				preferFood: traveler.preferFood,
				preferHotel: traveler.preferHotel,
				preferRoom: traveler.preferRoom,
				preferBed: traveler.preferBed,
				preferAirline: traveler.preferAirline,
				preferSeat: traveler.preferSeat,
				preferEtc: traveler.preferEtc,
				cautionFoodAllergic: traveler.cautionFoodAllergic,
				cautionMedicalInfo: traveler.cautionMedicineAllergic,
				cautionEtcWarning: traveler.cautionEtcWarning,
			};
			const payload = isCreateMode
				? Object.keys(requestBody).reduce((acc, key) => {
						const value = requestBody[key];
						if (value == null) return acc;
						if (typeof value === 'string' && !value.trim()) return acc;
						acc[key] = value;
						return acc;
				  }, {})
				: requestBody;

			// If image wasn't changed, omit `profileImageBinary`.
			if (avatarFileRef.current) {
				const binary = profileImageBinaryRef.current ? profileImageBinaryRef.current : await fileToBase64(avatarFileRef.current);
				profileImageBinaryRef.current = binary;
				payload.profileImageBinary = binary;
			}

			const request = isCreateMode ? await APIPost('travelers', payload) : await APIPut('travelers/' + travelerIdForApi, payload);
			if (request && request.status >= 200 && request.status < 300) {
				if (isCreateMode) {
					const createdId =
						(request.data && request.data.id != null && request.data.id) ||
						(request.data && request.data.data && request.data.data.id != null && request.data.data.id) ||
						null;
					if (createdId != null) {
						props.history.replace(AppConfig.appPath + '/travelers/' + createdId);
						toast.success('สร้าง Traveler สำเร็จ');
						window.location.reload();
						return;
					}
				}

				toast.success('Traveler profile บันทึกสำเร็จ');
				const apiTravelerPayload =
					request && request.data && request.data.data && typeof request.data.data === 'object' ? request.data.data : request && request.data;
				const refreshedTraveler = mapTravelerPayload(apiTravelerPayload);
				setTraveler(refreshedTraveler);
				originalTravelerRef.current = { ...refreshedTraveler };
				originalGeoRef.current = { selectedProvince, selectedCity, selectedTown };
				setIsEditingProfile(false);
				avatarFileRef.current = null;
				profileImageBinaryRef.current = null;
			} else {
				const errors = request && request.data && request.data.errors ? request.data.errors : [];
				if (errors) {
					Object.keys(errors).forEach(key => {
						errors[key].forEach(error => {
							toast.error(error);
						});
					});
				} else {
					toast.error('ไม่สามารถบันทึกข้อมูลผู้เดินทางได้ กรุณาลองใหม่อีกครั้ง');
				}
				console.log('Failed to update traveler profile', request);
			}
		} catch (e) {
			toast.error('ไม่สามารถบันทึกข้อมูลผู้เดินทางได้ 500');
			console.log(e);
		} finally {
			setIsSavingProfile(false);
		}
	}, [APIPost, APIPut, fileToBase64, isCreateMode, isSavingProfile, props.history, selectedCity, selectedProvince, selectedTown, traveler, travelerIdForApi]);

	const handleAvatarClick = useCallback(() => {
		if (fileInputRef.current) fileInputRef.current.click();
	}, []);

	const handleAvatarChange = useCallback(event => {
		const file = event.target.files && event.target.files[0];
		if (!file) return;
		if (avatarObjectUrlRef.current && avatarObjectUrlRef.current !== originalAvatarUrlRef.current) URL.revokeObjectURL(avatarObjectUrlRef.current);
		avatarFileRef.current = file;
		profileImageBinaryRef.current = null;
		avatarObjectUrlRef.current = URL.createObjectURL(file);
		setTraveler(prev => ({ ...prev, avatarUrl: avatarObjectUrlRef.current }));
	}, []);

	const handleTravelerChange = useCallback((key, value) => {
		if (key === 'province') {
			setSelectedProvince(value);
			setSelectedCity(null);
			setSelectedTown(null);
			setCitySelectOptions(getCitySelectOptions(value));
			setTownSelectOptions([]);
			setTraveler(prev => ({
				...prev,
				province: value && value.label != null ? value.label : '',
				city: '',
				town: '',
				postcode: '',
			}));
			return;
		}
		if (key === 'city') {
			const prov = selectedProvinceRef.current;
			setSelectedCity(value);
			setSelectedTown(null);
			setTownSelectOptions(getTownSelectOptions(prov, value));
			setTraveler(prev => ({
				...prev,
				city: value && value.label != null ? value.label : '',
				town: '',
				postcode: '',
			}));
			return;
		}
		if (key === 'town') {
			const zip = value && value.zipcode != null ? String(value.zipcode) : '';
			setSelectedTown(value);
			setTraveler(prev => ({
				...prev,
				town: value && value.label != null ? value.label : '',
				postcode: zip,
			}));
			return;
		}
		if (key === 'firstName' || key === 'lastName') {
			setProfileFieldErrors(prev => ({ ...prev, [key]: !String(value || '').trim() }));
		}
		setTraveler(prev => ({ ...prev, [key]: value }));
	}, []);

	/** NeedTab calls handleListChange(fieldKey, value) */
	const handleListChange = useCallback((key, value) => {
		setTraveler(prev => ({ ...prev, [key]: value }));
	}, []);

	const isNameExisting = (firstName, middleName, lastName) => {
		const filteredParts = [firstName, middleName, lastName].filter(v => v != null && String(v).trim() !== '');
		if (filteredParts.length) {
			return true;
		}
		return false;
	};

	const joinNameParts = (firstName, middleName, lastName) => [firstName, middleName, lastName].filter(v => v != null && String(v).trim() !== '').join(' ');

	const englishNameWithTitle = () => {
		const name = joinNameParts(traveler.firstName, traveler.middleName, traveler.lastName);
		const t = String(traveler.title || '').trim();
		if (!name) return t || '';
		return t ? `${t} ${name}` : name;
	};

	const thaiNameLine = () => joinNameParts(traveler.thaiFirstName, traveler.thaiMiddleName, traveler.thaiLastName);
	const nationalitySuffix = () => {
		const raw = String(traveler.nationality || '').trim();
		if (!raw) return '';
		const match = NATIONALITY_OPTIONS.find(opt => String(opt.value) === raw);
		const label = match && match.label ? match.label : raw;
		return ` [${label}]`;
	};

	const addressText = () => {
		let text = '';
		if (traveler.address1) text += traveler.address1 + ' ';
		if (traveler.province === 'กรุงเทพมหานคร') {
			if (traveler.town) text += 'เขต ' + traveler.town + ' ';
			if (traveler.city) text += 'แขวง ' + traveler.city + ' ';
			if (traveler.province) text += traveler.province + ' ';
		} else {
			if (traveler.town) text += 'ตำบล ' + traveler.town + ' ';
			if (traveler.city) text += 'อำเภอ ' + traveler.city + ' ';
			if (traveler.province) text += 'จังหวัด ' + traveler.province + ' ';
		}
		if (traveler.postcode) text += traveler.postcode + ' ';
		return text.trim() || '---';
	};

	return (
		<div className="travelers-page traveler-detail-page">
			<div className="container travelers-content" style={{ paddingTop: 30 }}>
				<BackButtonRouter title="กลับ" />

				<div className="traveler-detail-card">
					{isLoadingTraveler ? <div>กำลังโหลดข้อมูลผู้เดินทาง...</div> : null}
					{isCreateMode ? <h1 className="title is-4">Create Traveler</h1> : null}
					<div className="columns is-centered">
						<div className="column is-2">
							{traveler.avatarUrl ? (
								<img
									className={`traveler-avatar ${isEditingProfile ? 'clickable' : ''}`}
									src={traveler.avatarUrl}
									alt={traveler.name}
									onClick={isEditingProfile ? handleAvatarClick : undefined}
								/>
							) : (
								<div
									className={`traveler-avatar ${isEditingProfile ? 'clickable' : ''}`}
									onClick={isEditingProfile ? handleAvatarClick : undefined}
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										backgroundColor: '#f5f5f5',
										color: '#999',
									}}
								>
									<FontAwesomeIcon icon={faImage} style={{ fontSize: 32 }} />
								</div>
							)}
							{isEditingProfile ? (
								<input ref={fileInputRef} className="traveler-file-input" type="file" accept="image/*" onChange={handleAvatarChange} />
							) : null}
						</div>
						<div className="column is-8">
							<div className="traveler-field" style={{ marginBottom: 10 }}>
								{isEditingProfile ? (
									<>
										<div className="columns is-vcentered">
											<div className="column is-narrow is-3">
												<div className="field" style={{ marginBottom: 0 }}>
													<div className="control">
														<div className="select is-small" style={{ fontSize: '1rem' }}>
															<select
																value={traveler.title}
																onChange={event => handleTravelerChange('title', event.target.value)}
																aria-label="Title (English)"
																style={{ fontSize: 'inherit' }}
															>
																<option value="">—</option>
																{ENGLISH_NAME_TITLE_OPTIONS.map(opt => (
																	<option key={opt} value={opt}>
																		{opt}
																	</option>
																))}
															</select>
														</div>
													</div>
												</div>
											</div>
											<div className="column is-4">
												<input
													className="input is-medium"
													type="text"
													value={traveler.thaiFirstName}
													onChange={event => handleTravelerChange('thaiFirstName', event.target.value)}
													placeholder="ชื่อ (ไทย)"
												/>
											</div>
											<div className="column is-4">
												<input
													className="input is-medium"
													type="text"
													value={traveler.thaiLastName}
													onChange={event => handleTravelerChange('thaiLastName', event.target.value)}
													placeholder="นามสกุล (ไทย)"
												/>
											</div>
										</div>
										<div className="columns">
											<div className="column is-narrow is-3">
												<div className="field" style={{ marginBottom: 0 }}>
													<div className="control">
														<div className="select is-medium is-fullwidth" style={{ minWidth: 160 }}>
															<select
																value={traveler.nationality}
																onChange={event => handleTravelerChange('nationality', event.target.value)}
																aria-label="สัญชาติ"
															>
																<option value="">สัญชาติ</option>
																{NATIONALITY_OPTIONS.map(opt => (
																	<option key={opt.value} value={opt.value}>
																		{opt.label}
																	</option>
																))}
															</select>
														</div>
													</div>
												</div>
											</div>
											<div className="column is-4">
												<input
													className="input is-medium"
													type="text"
													value={traveler.firstName}
													onChange={event => handleTravelerChange('firstName', event.target.value)}
													placeholder="First Name"
													style={profileFieldErrors.firstName ? { borderColor: '#DC1818' } : undefined}
												/>
											</div>
											<div className="column is-4">
												<input
													className="input is-medium"
													type="text"
													value={traveler.lastName}
													onChange={event => handleTravelerChange('lastName', event.target.value)}
													placeholder="Last Name"
													style={profileFieldErrors.lastName ? { borderColor: '#DC1818' } : undefined}
												/>
											</div>
										</div>
									</>
								) : (
									<>
										{isNameExisting(traveler.thaiFirstName, traveler.thaiMiddleName, traveler.thaiLastName) ? (
											<>
												<h1 className="title is-4">{(thaiNameLine() || '—') + (thaiNameLine() ? nationalitySuffix() : '')}</h1>
												{isNameExisting(traveler.firstName, traveler.middleName, traveler.lastName) ||
												String(traveler.title || '').trim() ? (
													<h3 className="subtitle is-4" style={{ fontSize: 16 }}>
														{englishNameWithTitle() || '—'}
													</h3>
												) : null}
											</>
										) : isNameExisting(traveler.firstName, traveler.middleName, traveler.lastName) ||
										  String(traveler.title || '').trim() ? (
											<h1 className="title is-4">
												{(englishNameWithTitle() || '—') + (englishNameWithTitle() ? nationalitySuffix() : '')}
											</h1>
										) : null}
									</>
								)}
							</div>
							<div style={{ height: 10 }} />
							<div className="columns traveler-contact-row">
								<div className="column is-5 traveler-contact-item">
									<span className="traveler-contact-icon-slot" aria-hidden="true">
										<PhoneIcon className="traveler-icon" />
									</span>
									{isEditingProfile ? (
										<input
											className="input traveler-inline-input"
											type="number"
											value={traveler.phone != null ? traveler.phone : ''}
											onChange={event => handleTravelerChange('phone', event.target.value)}
											placeholder="เบอร์โทรศัพท์"
										/>
									) : (
										<span>{traveler.phone || '---'}</span>
									)}
								</div>
								<div className="column is-5 traveler-contact-item">
									<span className="traveler-contact-icon-slot" aria-hidden="true">
										<EmailIcon className="traveler-icon" />
									</span>
									{isEditingProfile ? (
										<input
											className="input traveler-inline-input"
											type="text"
											value={traveler.email}
											onChange={event => handleTravelerChange('email', event.target.value)}
											placeholder="Email"
										/>
									) : (
										<span
											className="traveler-contact-body"
											style={{
												display: 'block',
												whiteSpace: 'pre-wrap',
												overflowWrap: 'anywhere',
												wordBreak: 'break-word',
											}}
										>
											{traveler.email || '---'}
										</span>
									)}
								</div>
							</div>
							<div className="columns traveler-contact-row">
								<div className="column is-5 traveler-contact-item">
									<span className="traveler-contact-icon-slot" aria-hidden="true">
										<BirthdayCakeIcon className="traveler-icon" />
									</span>
									{isEditingProfile ? (
										<input
											className="input traveler-inline-input"
											type="date"
											max={new Date().toISOString().split('T')[0]}
											value={traveler.birthday}
											onChange={event => handleTravelerChange('birthday', event.target.value)}
											placeholder="วันเกิด"
										/>
									) : (
										<span>{traveler.birthday || '---'}</span>
									)}
								</div>
								{isCreateMode || isEditingProfile ? null : (
									<div className="column is-5 traveler-contact-item">
										<span className="traveler-contact-icon-slot" aria-hidden="true">
											<FontAwesomeIcon icon={faChild} className="traveler-icon" />
										</span>

										<span>{traveler.age !== '' && traveler.age != null ? traveler.age : '---'}</span>
									</div>
								)}
							</div>
							<div className="columns traveler-contact-row">
								<div className="column is-12 traveler-contact-item">
									<span className="traveler-contact-icon-slot" aria-hidden="true">
										<HouseIcon className="traveler-icon" />
									</span>
									{isEditingProfile ? (
										<div className="column is-fullwidth traveler-contact-body">
											<div className="columns">
												<div className="column is-12">
													<input
														className="input  traveler-address-input"
														type="text"
														value={traveler.address1}
														onChange={event => handleTravelerChange('address1', event.target.value)}
														placeholder="ที่อยู่"
													/>
												</div>
											</div>

											<div className="columns">
												<div className="column is-6">
													<Select
														className="is-fullwidth"
														name="province"
														value={selectedProvince}
														placeholder="จังหวัด"
														clearable={false}
														onChange={value => handleTravelerChange('province', value)}
														options={provinceSelectOptions}
														menuPortalTarget={document.body}
														styles={TRAVELER_ADDRESS_SELECT_STYLES}
													/>
												</div>
												<div className="column is-6">
													<Select
														className="is-fullwidth"
														name="city"
														value={selectedCity}
														placeholder="แขวง/อำเภอ"
														clearable={false}
														onChange={value => handleTravelerChange('city', value)}
														options={citySelectOptions}
														menuPortalTarget={document.body}
														styles={TRAVELER_ADDRESS_SELECT_STYLES}
													/>
												</div>
											</div>
											<div className="columns">
												<div className="column is-6">
													<Select
														className="is-fullwidth"
														name="town"
														value={selectedTown}
														placeholder="เขตตำบล"
														clearable={false}
														onChange={value => handleTravelerChange('town', value)}
														options={townSelectOptions}
														menuPortalTarget={document.body}
														styles={TRAVELER_ADDRESS_SELECT_STYLES}
													/>
												</div>
												<div className="column is-6">
													<input
														className="input is-fullwidth"
														type="number"
														value={traveler.postcode != null && traveler.postcode !== '' ? traveler.postcode : ''}
														onChange={event => handleTravelerChange('postcode', event.target.value)}
													/>
												</div>
											</div>
										</div>
									) : (
										<span className="traveler-contact-body">{addressText()}</span>
									)}
								</div>
							</div>
							<div className="columns traveler-contact-row">
								<div className="column is-5 traveler-contact-item">
									<span className="traveler-contact-icon-slot" aria-hidden="true">
										<FontAwesomeIcon icon={faIdCard} className="traveler-icon" />
									</span>
									{isEditingProfile ? (
										<input
											className="input traveler-inline-input"
											type="text"
											value={traveler.idCardNumber}
											onChange={event => handleTravelerChange('idCardNumber', event.target.value)}
											placeholder="เลขบัตรประชาชน"
											style={{ maxWidth: '100%' }}
										/>
									) : (
										<span>{traveler.idCardNumber || '---'}</span>
									)}
								</div>
							</div>
							<div className="columns traveler-contact-row">
								<div className="column is-5 traveler-contact-item">
									<span className="traveler-contact-icon-slot" aria-hidden="true">
										<FontAwesomeIcon icon={faPassport} className="traveler-icon" />
									</span>
									{isEditingProfile ? (
										<input
											className="input traveler-inline-input"
											type="text"
											value={traveler.passportNumber}
											onChange={event => handleTravelerChange('passportNumber', event.target.value)}
											placeholder="Passport ID"
										/>
									) : (
										<span>{traveler.passportNumber || '---'}</span>
									)}
								</div>
								<div className="column is-5 traveler-contact-item">
									<span className="traveler-contact-icon-slot" aria-hidden="true" title="Passport expire date">
										<FontAwesomeIcon icon={faCalendarDays} className="traveler-icon" />
									</span>
									{isEditingProfile ? (
										<input
											className="input traveler-inline-input"
											type="date"
											value={traveler.passportExpiryDate}
											onChange={event => handleTravelerChange('passportExpiryDate', event.target.value)}
											placeholder="Passport expire date"
											title="Passport expire date"
										/>
									) : (
										<span title="Passport expire date">{traveler.passportExpiryDate || '---'}</span>
									)}
								</div>
							</div>
						</div>
						<div className="column is-2 has-text-right">
							{isEditingProfile || isCreateMode ? (
								<div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
									<button
										type="button"
										className="button is-medium"
										style={{
											backgroundColor: '#22c65b',
											borderColor: '#22c65b',
											color: '#fff',
											opacity: isSavingProfile ? 0.7 : 1,
										}}
										onClick={handleSaveProfile}
										disabled={isSavingProfile}
										aria-label="บันทึก"
										title="บันทึก"
									>
										<FontAwesomeIcon icon={faCheck} />
									</button>
									<button
										type="button"
										className="button is-medium"
										style={{
											backgroundColor: '#DC1818',
											borderColor: '#DC1818',
											color: '#fff',
											opacity: isSavingProfile ? 0.7 : 1,
										}}
										onClick={handleCancelProfile}
										disabled={isSavingProfile}
										aria-label="ยกเลิก"
										title="ยกเลิก"
									>
										<FontAwesomeIcon icon={faTimes} />
									</button>
								</div>
							) : (
								<button type="button" className="button is-info is-medium" onClick={startEditProfile} aria-label="แก้ไข" title="แก้ไข">
									<FontAwesomeIcon icon={faPencilAlt} />
								</button>
							)}
						</div>
					</div>

					{isCreateMode ? null : (
						<div className="traveler-tabs columns is-centered is-mobile">
							<div className="tabs traveler-tabs-list is-centered">
								<ul>
									<li className={activeTab === 'needs' ? 'is-active' : ''}>
										<a onClick={() => setActiveTab('needs')}>ความต้องการ</a>
									</li>
									<li className={activeTab === 'passport' ? 'is-active' : ''}>
										<a onClick={() => setActiveTab('passport')}>Passport</a>
									</li>
									<li className={activeTab === 'visa' ? 'is-active' : ''}>
										<a onClick={() => setActiveTab('visa')}>VISA</a>
									</li>
								</ul>
							</div>
						</div>
					)}

					{!isCreateMode && activeTab === 'needs' ? (
						<NeedTab
							traveler={traveler}
							isEditingNeeds={isEditingNeeds}
							isSavingNeeds={isSavingNeeds}
							handleListChange={handleListChange}
							onStartEditNeeds={startEditNeeds}
							onSaveNeeds={handleSaveNeeds}
							onCancelNeeds={handleCancelNeeds}
						/>
					) : null}

					{!isCreateMode && activeTab === 'passport' ? (
						<PassportTab traveler={traveler} travelerId={travelerIdForApi} MAX_IMAGE_BYTES={MAX_IMAGE_BYTES} />
					) : null}
					{!isCreateMode && activeTab === 'visa' ? (
						<VisaTab traveler={traveler} travelerId={travelerIdForApi} MAX_IMAGE_BYTES={MAX_IMAGE_BYTES} />
					) : null}

					{isCreateMode ? null : (
						<div className="traveler-subtabs">
							<div className="tabs traveler-tabs-list">
								<ul>
									<li className={activeProgramTab === 'incentive' ? 'is-active' : ''}>
										<a onClick={() => setActiveProgramTab('incentive')}>Incentive</a>
									</li>
									<li className={activeProgramTab === 'fit-visa' ? 'is-active' : ''}>
										<a onClick={() => setActiveProgramTab('fit-visa')}>FIT VISA</a>
									</li>
									<li className={activeProgramTab === 'fit-flight' ? 'is-active' : ''}>
										<a onClick={() => setActiveProgramTab('fit-flight')}>FIT Flight</a>
									</li>
									<li className={activeProgramTab === 'fit-ticket' ? 'is-active' : ''}>
										<a onClick={() => setActiveProgramTab('fit-ticket')}>FIT Ticket</a>
									</li>
									<li className={activeProgramTab === 'fit-hotel' ? 'is-active' : ''}>
										<a onClick={() => setActiveProgramTab('fit-hotel')}>FIT Hotel</a>
									</li>
									<li className={activeProgramTab === 'fit-insure' ? 'is-active' : ''}>
										<a onClick={() => setActiveProgramTab('fit-insure')}>FIT Insure</a>
									</li>
									<li className={activeProgramTab === 'fit-car' ? 'is-active' : ''}>
										<a onClick={() => setActiveProgramTab('fit-car')}>FIT Car rent</a>
									</li>
									<li className={activeProgramTab === 'fit-translate' ? 'is-active' : ''}>
										<a onClick={() => setActiveProgramTab('fit-translate')}>FIT Translate</a>
									</li>
									<li className={activeProgramTab === 'fit-internet' ? 'is-active' : ''}>
										<a onClick={() => setActiveProgramTab('fit-internet')}>FIT Internet</a>
									</li>
								</ul>
							</div>
						</div>
					)}

					{!isCreateMode && activeProgramTab === 'incentive' ? <IncentiveTab travelerId={travelerIdForApi} /> : null}
					{!isCreateMode && activeProgramTab === 'fit-visa' ? <FitVisaTab travelerId={travelerIdForApi} /> : null}
					{!isCreateMode && activeProgramTab === 'fit-flight' ? <FitFlightTab travelerId={travelerIdForApi} /> : null}
					{!isCreateMode && activeProgramTab === 'fit-ticket' ? <FitTicketTab travelerId={travelerIdForApi} /> : null}
					{!isCreateMode && activeProgramTab === 'fit-hotel' ? <FitHotelTab travelerId={travelerIdForApi} /> : null}
					{!isCreateMode && activeProgramTab === 'fit-insure' ? <FitInsureTab travelerId={travelerIdForApi} /> : null}
					{!isCreateMode && activeProgramTab === 'fit-car' ? <FitCarTab travelerId={travelerIdForApi} /> : null}
					{!isCreateMode && activeProgramTab === 'fit-translate' ? <FitTranslateTab travelerId={travelerIdForApi} /> : null}
					{!isCreateMode && activeProgramTab === 'fit-internet' ? <FitInternetTab travelerId={travelerIdForApi} /> : null}
				</div>
			</div>
		</div>
	);
}
